import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { MainPage } from "../pages/MainPage";
import { useAppSelector } from '../store/hooks';
import { ItemEditPage } from '../pages/ItemEditPage';
import { SignupPage } from '../pages/SignupPage';
import { ItemDetailPage } from '../pages/ItemDetailPage';
import { MainLayout } from '../layouts/MainLayout';
import { LoginPage } from '../pages/LoginPage';
import { ProfileEdit } from '../pages/ProfileEdit';
import { UserRentalsList } from '../pages/UserRentalsList';
import { ChatView } from '../pages/ChatView';
import { ProfilePage } from '../pages/ProfilePage';
import { MainPageMobile } from '../pages/MainPageMobile';
import { PrivacyPolicyPage } from '../pages/PrivacyPolicyPage';
import { TermsOfService } from '../pages/TermsOfService';
import { UserRentedList } from '../pages/UserRentedList';
import { UserAdvertsList } from '../pages/UserAdvertsList';
import { Error404 } from '../pages/Error404';
import { ChatsPage } from '../pages/ChatsPage';
import { EmailConfirmationPage } from '../pages/EmailConfirmationPage';
import { FavoritesPage } from '../pages/FavoritesPage';
import ThankYouPage from '../pages/PaymentCompletedPage';
import PaymentCompletedPage from '../pages/PaymentCompletedPage';
import { ContactPage } from '../pages/ContactPage';
import { SmartIDVerificationState } from '../components/login/SmartIDLoading';
import { SmartIdVerificationPage } from '../pages/SmartIdVerificationPage';
import { ProfileViewPage } from '../pages/ProfileViewPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';
import PriceTablePage from '../pages/PriceTablePage';
import { ResetPwdEmailPage } from '../pages/ResetPwdEmailPage';
import { UserRole } from '../dto/auth/User';
import { AdminPage } from '../pages/AdminPage';
import { AdvertDetailPage } from '../pages/AdvertDetailPage';

const PrivateRoutes = () => {
  const userState = useAppSelector((state) => state.auth.user);
  const loadingAuth = useAppSelector((state) => state.auth.loading);
  const apiAuthInitialized = useAppSelector((state) => state.auth.apiAuthInitilized);

  if (loadingAuth || !apiAuthInitialized) {
    return <></>
  }

  return (userState || loadingAuth) ? <Outlet />
    : <Navigate to="/login" replace />;
}

const AdminRoutes = () => {
  const userRole = useAppSelector((state) => state.auth.user?.role);

  if (userRole !== UserRole.ADMIN) {
    return <>Puudub access</>
  }
  
  return <Outlet />
}

const router = createBrowserRouter([
  {
    element: <MainLayout test={''} />,
    children: [
      {
        path: '/',
        element: window.innerWidth > 1024 ? <MainPage showSearchBarArea={true} /> : <MainPageMobile showSearchBar={true} />
      },
      {
        path: '/search',
        element: window.innerWidth > 1024 ? <MainPage showSearchBarArea={false} /> : <MainPageMobile showSearchBar={false} />
      },
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/signup',
        element: <SignupPage />,
      },
      {
        path: '/detail/:productId',
        element: <ItemDetailPage />,
      },
      {
        path: '/privacy-policy',
        element: <PrivacyPolicyPage />
      },
      {
        path: '/terms-of-service',
        element: <TermsOfService />
      },
      {
        path: '/email-verify',
        element: <EmailConfirmationPage />
      },
      {
        path: '/reset-password-email',
        element: <ResetPwdEmailPage />
      },
      {
        path: '/404',
        element: <Error404 />,
      },
      {
        path: '/contact',
        element: <ContactPage />,
      },
      {
        path: '/pricing',
        element: <PriceTablePage />
      },
      {
        path: '/reset-password',
        element: <ResetPasswordPage />
      },
      {
        element: <PrivateRoutes />,
        children: [

          // {
          //   path: '/profile_edit',
          //   element: <ProfileEdit />
          // },
          {
            path: '/my_rentals_status',
            element: <UserRentalsList />
          },
          {
            path: '/profile_edit',
            element: <ProfilePage />
          },
          {
            path: '/my-adverts',
            element: <UserAdvertsList />
          },
          {
            path: '/my-orders',
            element: <UserRentedList />
          },
          {
            path: '/verify-smart-id',
            element: <SmartIdVerificationPage />
          },
          {
            path: '/profile/:profileId',
            element: <ProfileViewPage />
          },
          /* {
            path: '/favorites',
            element: <FavoritesPage/>
          }, */
          {
            path: '/rentals-chats',
            element: <ChatsPage pageType='rentals' />
          },
          {
            path: '/chats',
            element: <ChatsPage pageType='rented' />
          },
          {
            path: '/payment',
            element: <PaymentCompletedPage />,
          },
          {
            path: '/edit',
            element: <ItemEditPage />
          },
          {
            path: '/admin',
            element: <AdminRoutes />,
            children: [
              {
                path: '/admin/',
                element: <AdminPage />,
              },
              {
                path: '/admin/advert/:advertId',
                element: <AdvertDetailPage />,
              }
            ]
          }
        ]
      }
    ]
  }
]);

export default router;